import { autoinject } from "aurelia-framework";
import { RightshipInspectionService } from "../../../services/rightship-inspection.service";
import { GetInspectionProposalInspectionInfoResponse, PartialInspectionLayoutModel, SubmitProposalStatusEnum, SubmmittedInspectionModel } from "../../../models/rightship-inspections.models";
import { RsInspectionRouteConstants } from "../../../constants/route.constants";
import { Router } from "aurelia-router";
import { TitleConst } from "../../../constants/title.constaints";
import { RightShipInspectionStatusEnum } from "@rightship-tech/rs-inspections-ui/models/rightship-inspection.models";

@autoinject
export class DeclineProposal {

    public declineInspections: SubmmittedInspectionModel;
    private _encryptedData: string;
    private declineProposalModel: GetInspectionProposalInspectionInfoResponse;
    public inspectionModel : PartialInspectionLayoutModel;
    public readonly title: string = TitleConst.DeclineProposal;

    constructor(private rightshipInspectionService: RightshipInspectionService, private router: Router) {
    }

    async activate(params: { encryptedData: string }) {
        this._encryptedData = decodeURIComponent(params.encryptedData);
        this.declineProposalModel = await this.rightshipInspectionService.getInspectionProposalInspectionInfo(this._encryptedData);
        if (this.declineProposalModel.hasSubmittedProposal || !this.declineProposalModel.isAssignmentActive
            || this.declineProposalModel.statusId == RightShipInspectionStatusEnum.Acceptable
            || this.declineProposalModel.statusId == RightShipInspectionStatusEnum.Acceptable
            || this.declineProposalModel.statusId == RightShipInspectionStatusEnum.Unacceptable
        ) {
            this.router.navigateToRoute(RsInspectionRouteConstants.CloseRequest, { 
                isDeclined: false,
                hideCloseTab: true,
                encryptedData: encodeURIComponent(this._encryptedData)
            });
            return;
        }
        this.declineInspections = {
            vesselName: this.declineProposalModel.vesselName,
            vesselImo: this.declineProposalModel.vesselImo,
            portName: this.declineProposalModel.portName,
            country: this.declineProposalModel.country,
            requestedInspectionDate: this.declineProposalModel.requestedInspectionDate
        }
        this.inspectionModel = {
            vesselDetails: {
                vesselName: this.declineProposalModel.vesselName,
                vesselImo: this.declineProposalModel.vesselImo,
            },
            portAndOperationalDetails: {
                port: this.declineProposalModel.portName,
                country: this.declineProposalModel.country,
                requestedInspectionDate: this.declineProposalModel.requestedInspectionDate
            },
            rightShipInspectionId : this.declineProposalModel.rightShipInspectionId?.toString()
        }
    }

    //navigate to the proposal page
    submitProposal() {
        this.router.navigateToRoute(RsInspectionRouteConstants.Proposal, { encryptedData: encodeURIComponent(this._encryptedData) });
    }

    //navigate to the close request page
    async declineRequest() {
        await this.rightshipInspectionService.saveInspectionProposal({ proposalStatus: SubmitProposalStatusEnum.Declined }, this._encryptedData);
        this.router.navigateToRoute(RsInspectionRouteConstants.CloseRequest, { 
            isDeclined: true,
            hideCloseTab: true,
            encryptedData: encodeURIComponent(this._encryptedData)
        });
    }
}